<template>
  <div>
    <Header></Header>
    <WorkCentersTable />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import WorkCentersTable from "@/components/production-planning/WorkCentersTable.vue";
import User from "@/models/User.js";
export default {
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
  },
  components: {
    Header,
    WorkCentersTable,
  },
};
</script>

<style>
</style>